import React, { useId } from 'react';

// The Matchback Overview's "Matched people" tile illustration: a bigger solid base-audience circle
// overlapped by a smaller dashed, gradient-stroked comparison-audience circle.
const MatchedPeopleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const gradientId = useId();

  return (
    <svg width="85" height="68" viewBox="0 0 85 68" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="33.5423" cy="33.5423" r="33.5423" fill="#DAF2FF" />
      <circle
        cx="63.0247"
        cy="33.5438"
        r="20.4811"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.72794"
        strokeDasharray="2.03 2.03"
      />
      <circle
        cx="63.0247"
        cy="33.5438"
        r="20.4811"
        stroke="white"
        strokeOpacity="0.1"
        strokeWidth="1.72794"
        strokeDasharray="2.03 2.03"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="41.6796"
          y1="16.2009"
          x2="87.7548"
          y2="23.8642"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1784EC" />
          <stop offset="0.5" stopColor="#FF8FA1" />
          <stop offset="1" stopColor="#FF6C0A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MatchedPeopleIcon;
